import _defineProperty from "@babel/runtime/helpers/defineProperty";
class ExperimentsStore {
  constructor() {
    _defineProperty(this, "experiments", {});
  }
  get() {
    return this.experiments;
  }
  set(experiments) {
    this.experiments = experiments;
  }
  enabled(experiment) {
    return this.experiments[experiment] === 'true';
  }
}
const isEnabled = experiment => () => getExperiments()[experiment] === 'true';
export const experimentsStore = new ExperimentsStore();
export const getExperiments = () => experimentsStore.get();
export const isPrivateGraphAPIEnabled = isEnabled('specs.vod.useGraphAPI');
export const isWixCodeSEOEnabled = isEnabled('specs.vod.wixCodeSEO');
//# sourceMappingURL=experiments.js.map